import Vue from 'vue'
import App from './App.vue'
import router from "@/router/router";
import store from "@/store/store";
// 阿里 icon
import "@/assets/icon/iconfont.css";
// public 组件
import publicComponents from "@/components/common/public";
// api
import { post, get, put, del, get_auth ,isIos } from "@/api/http";
// 微信支付
import { payAwaken } from "@/utils/wxPay";
// 微信分享
import { wxShare } from "@/utils/wxShare";
// 微信支付
import { QRCode } from "@/utils/wxQRCode";
// less
import "@/style/common/common.less";
// UI 框架
import "@/utils/UI";


// yyyy-mm-dd
//时间戳转换方法    date:时间戳数字
Vue.prototype.formatDate= function (data) {
  var date= null;
  if(data) {
    date = new Date(data);
  }else {
    date = new Date();
  }

  var YY = date.getFullYear() + '-';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  // eslint-disable-next-line no-unused-vars
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  // eslint-disable-next-line no-unused-vars
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  // eslint-disable-next-line no-unused-vars
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  // return YY + MM + DD +" "+hh + mm + ss;
  return YY + MM + DD;
}

Vue.prototype.GetAge = function (identityCard) {
  var len = (identityCard + "").length;
  if (len == 0) {
    return 0;
  } else {
    if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
    {
      return 0;
    }
  }
  var strBirthday = "";
  if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
  {
    strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
  }
  if (len == 15) {
    strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date();
  var age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

// api
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$del = del;
Vue.prototype.$auth= get_auth;
Vue.prototype.$isIos= isIos;

// 微信支付
Vue.prototype.$wxPay = payAwaken;
// 微信分享
Vue.prototype.$wxShare = wxShare;
// 微信扫一扫
Vue.prototype.$wxQRCode = QRCode;
// vuex
// Vue.prototype.$store = store;
// public 组件
Vue.use(publicComponents);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
